const API_URL = '/api';

const fetchData = async (url, options = {}) => {
    try {
        // console.log(`📡 Fetching: ${url}`); // URL loggen
        const res = await fetch(url, options);
        const data = await res.json();

        if (!res.ok) {
            console.error("❌ API-Fehler:", data);
            throw new Error(data.message || "API request failed");
        }

        return data;
    } catch (error) {
        console.error("🚨 Fetch Error:", error);
        throw error;
    }
};

export const registerUser = (data) => {
    return fetchData(`${API_URL}/users/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
};

export const loginUser = (data) => {
    return fetchData(`${API_URL}/users/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    }).then(response => ({
        user: response.user,  // Speichert userData
        token: response.token // Speichert Token
    }));
};


export const getNews = () => {
    return fetchData(`${API_URL}/news`);
};

export const getCurrentNews = () => {
    return fetchData(`${API_URL}/news/current`);
};

export const getByNewsSiteName = (articleSiteName) => {
    return fetchData(`${API_URL}/news/${articleSiteName}`);
};

export const getTests = () => {
    return fetchData(`${API_URL}/tests`);
};

export const getByTestID = (articleID) => {
    return fetchData(`${API_URL}/tests/${articleID}`);
};

// Forum-API
export const getCategories = () => {
    return fetchData(`${API_URL}/forum/categories`);
};

export const getCategoryByName = (categoryName) => {
    return fetchData(`${API_URL}/forum/categories/category/${categoryName}`);
};

export const getThreads = (page = 1, categoryId = null) => {
    let url = `${API_URL}/forum/threads?page=${page}`;
    if (categoryId) {
        url += `&category_id=${categoryId}`;
    }
    // console.log(fetchData(url));
    return fetchData(url);
};

export const getThreadDetails = (id) => {
    const url = `${API_URL}/forum/threads/${id}`;
    // console.log(`Fetching URL: ${url}`); // Logge die URL zur Überprüfung
    return fetchData(url);
};

// Neue Funktion zum Abrufen der Posts eines Threads
export const getPostsByThread = (threadId) => {
    const url = `${API_URL}/forum/posts/threads/${threadId}/posts`;
    // console.log(`📡 Fetching Posts from Thread: ${url}`); // URL loggen
    return fetchData(url);
};

export const getPostDetails = (threadId, postId) => {
    return fetchData(`${API_URL}/forum/threads/${threadId}/posts/${postId}`);
};

// Weitere API-Methoden für das Forum
export const createPost = (threadId, htmlContent, userId) => {
    const token = localStorage.getItem('token'); // Token holen
    if (!token) {
        throw new Error("Kein Token gefunden, Zugriff verweigert.");
    }

    return fetchData(`${API_URL}/forum/posts/threads/${threadId}/posts`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` // Füge das Token hinzu
        },
        body: JSON.stringify({
            thread_id: threadId,
            content: htmlContent,
            user_id: userId,
        }),
    });
};

export const getLastPost = async (threadId) => {
    try {
        const response = await fetch(`/api/forum/posts/threads/${threadId}/last-post`);
        if (!response.ok) {
            throw new Error("Kein letzter Beitrag gefunden");
        }
        return await response.json();
    } catch (error) {
        console.error("Fehler beim Laden des letzten Beitrags:", error);
        return null;
    }
};

export const getLastPostByCategory = async (categoryId) => {
    try {
        const response = await fetch(`/api/forum/posts/categories/${categoryId}/last-post`);
        if (!response.ok) {
            throw new Error("Kein letzter Beitrag gefunden");
        }
        console.log(response);
        return await response.json();
    } catch (error) {
        console.error("Fehler beim Laden des letzten Beitrags:", error);
        return null;
    }
};

export const getThreadCountByCategory = async (categoryId) => {
    const response = await fetch(`/api/forum/threads/category/${categoryId}/count`);
    if (!response.ok) throw new Error("Fehler beim Laden der Thread-Anzahl");
    return response.json();
};

export const getPostCountByCategory = async (categoryId) => {
    const response = await fetch(`/api/forum/posts/category/${categoryId}/count`);
    if (!response.ok) throw new Error("Fehler beim Laden der Beitrags-Anzahl");
    return response.json();
};

// Funktion zum Abrufen von Benutzerdaten anhand der User ID
export const getUserDataById = async (userId) => {
    try {
        const response = await fetch(`/api/users/${userId}`);
        if (!response.ok) {
            throw new Error("Benutzer nicht gefunden");
        }
        const data = await response.json();
        return data.user;
    } catch (error) {
        console.error(error);
        throw new Error("Fehler beim Abrufen der Benutzerdaten");
    }
};

export const getPostCountByThread = async (threadId) => {
    const response = await fetch(`/api/forum/posts/thread/${threadId}/count`);
    return response.json();
};

export const createThread = (categoryId, title, description, content, userId) => {
    const token = localStorage.getItem('token'); // Token holen
    if (!token) {
        throw new Error("Kein Token gefunden, Zugriff verweigert.");
    }

    return fetchData(`${API_URL}/forum/threads`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` // Füge das Token hinzu
        },
        body: JSON.stringify({
            category_id: categoryId,
            title: title,
            description: description,
            content: content,
            user_id: userId,
        }),
    });
};

